import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthStore } from '../store/AuthContext';
import IconAsterRojo from '../Icons/IconAsterRojo';
import { PriceFormatter } from '../utils/PriceFormatter';
import { IconAsterBlanco } from '../Icons';
import { HostProvider } from '../utils/HostProvider';

type Props = {
  titleName: string;
  titleValue?: number;
  numText?: any;
  page: string;
  isLoad?: boolean;
};

const Title: FC<Props> = ({ titleName, titleValue, page, isLoad, numText }) => {
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const isEroski = HostProvider.isEroski();

  const { moneda } = dataUser.user;

  const priceFormatter = (value: any) => {
    return PriceFormatter.formatStringAsPrice(value as string, '');
  };

  const getIconAster = () => {
    if (page === 'puntos-travel') {
      return (
        <>
          <IconAsterBlanco />
        </>
      );
    }
    if (page === 'saldo' || page === 'ahorros') {
      return (
        <>
          <IconAsterRojo />
        </>
      );
    }
    return '';
  };

  const getSup = () => {
    if (page === 'puntos-travel') {
      return 'ptos';
    }
    if (page === 'saldo' || page === 'ahorros') {
      return moneda === 'euro' ? t('euro') : t('cc');
    }
    return '';
  };

  const getTitleValue = () => {
    if (page === 'puntos-travel' && titleValue) {
      return titleValue.toLocaleString('de-DE');
    }
    if ((page === 'saldo' || page === 'ahorros') && titleValue) {
      return priceFormatter(titleValue);
    }
    return '';
  };
  const isNegativeNumber = parseInt(getTitleValue(), 10) > 0;

  return (
    <>
      <div className="titulo-seccion">
        <h1 className="titulo-seccion__title">{titleName}</h1>

        {/* eslint-disable-next-line consistent-return */}
        {(() => {
          if (isLoad) {
            return (
              <>
                {(() => {
                  if (isEroski) {
                    return (
                      <>
                        <div className="titulo-seccion__deco">
                          {getIconAster()}
                        </div>
                      </>
                    );
                  }
                  return false;
                })()}
                {(() => {
                  if (
                    page !== 'ahorros' ||
                    (titleValue && titleValue !== 0 && isNegativeNumber)
                  ) {
                    return (
                      <>
                        <div className="titulo-seccion__num">
                          <p className="saldo u-margin-bottom-small">
                            {getTitleValue()} <sup>{getSup()}</sup>
                          </p>
                          <p className="text">{numText}</p>
                        </div>
                      </>
                    );
                  }
                  return false;
                })()}
              </>
            );
          }
          return false;
        })()}
      </div>
    </>
  );
};

export default Title;
